import t from "@emotion/styled/base";
import { Stack as b } from "../../Stack/index.js";
function e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const a = /* @__PURE__ */ t(b, process.env.NODE_ENV === "production" ? {
  target: "e1lk6j590"
} : {
  target: "e1lk6j590",
  label: "FilesDetails"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvRHJvcHpvbmUvUmVqZWN0ZWRNdWx0aXBsZURvY3VtZW50VGh1bWIvUmVqZWN0ZWRNdWx0aXBsZURvY3VtZW50VGh1bWIuc3R5bGVkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUkrRCIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9wYXJ0b28tdWkvcGFydG9vLXVpL3BhY2thZ2VzL3VpL3NyYy9jb21wb25lbnRzL0Ryb3B6b25lL1JlamVjdGVkTXVsdGlwbGVEb2N1bWVudFRodW1iL1JlamVjdGVkTXVsdGlwbGVEb2N1bWVudFRodW1iLnN0eWxlZC50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQsIHsgU3R5bGVkQ29tcG9uZW50IH0gZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgU3RhY2sgfSBmcm9tICcuLi8uLi9TdGFjayc7XG5cbmV4cG9ydCBjb25zdCBGaWxlc0RldGFpbHM6IFN0eWxlZENvbXBvbmVudDxhbnk+ID0gc3R5bGVkKFN0YWNrKWBcbiAgICB3aWR0aDogMTAwJTtcbmA7XG4iXX0= */",
  toString: e
});
export {
  a as FilesDetails
};
